<template>
  <div>
    <!-- Atenção -->
    <vs-alert style="height: auto" active="true" color="danger" class="mb-5">
      Importante: os dados emitidos pelos relatórios são sensíveis, e de
      responsabilidade exclusiva do autor.
    </vs-alert>

    <div v-if="!isLoading">
      <!-- Favoritos -->
      <div class="flex justify-end">
        <FormFavoritos
          :idEmpresa="idEmpresa"
          @favoritoSelecionado="favoritoSelecionado"
          :abreModalFavoritos="abreModalFavoritos"
          ref="formFavoritos"
        />
      </div>

      <!-- Lista Relatórios -->
      <div class="my-3">
        <p class="mb-2">Selecione o tipo de relatório a ser criado:</p>

        <div class="flex gap-3 mb-5 flex-wrap">
          <div v-for="item in listRelatorios" :key="item.idRelatorio">
            <vs-button
              v-if="$can(item.nomeRelatorio, 'Dinamicos')"
              :color="item.selecionado ? '#C3E1FF' : '#E9E9E9'"
              :text-color="item.selecionado ? '#114880' : '#626262'"
              @click="selecionaRelatorio(item)"
              >{{ item.nomeRelatorio }}
            </vs-button>
          </div>
        </div>
      </div>

      <div
        class="vx-row"
        v-if="filtroPreparado"
        :key="relatorioSelecionado.idRelatorio"
      >
        <!-- Campos -->
        <div class="vx-col sm:w-1/3 w-full">
          <FormCampos
            :listCampos="listCampos"
            @camposSelecionados="alteraCamposSelecionados"
            :camposFavoritos="camposFavoritoSelecionado"
          />
        </div>

        <!-- Filtros -->
        <div class="vx-col sm:w-2/3 w-full">
          <FormFiltros
            :listFiltros="listFiltros"
            :listas="listas"
            :filtrosFavoritos="filtrosFavoritoSelecionado"
            @filtrosSelecionados="alteraFiltrosSelecionados"
            @gerarRelatorio="geraRelatorioDinamico"
          />
        </div>
      </div>
    </div>

    <!-- Conteúdo Relatório -->
    <div
      class="vx-row"
      v-if="filtroPreparado"
      :key="relatorioSelecionado.idRelatorio"
    >
      <div class="vx-col w-full">
        <FormRelatorio
          :relatorioGerado="relatorioGerado"
          @abreModalFavoritos="abreModalFavoritos"
        />
      </div>
    </div>
  </div>
</template>
<script>
import service from '../../../../services';
import notify from '../../../../utils/notify';
import jwt from 'jsonwebtoken';

import FormCampos from './components/FormCampos.vue';
import FormFiltros from './components/FormFiltros.vue';
import FormRelatorio from './components/FormRelatorio.vue';
import FormFavoritos from './components/FormFavoritos.vue';

export default {
  components: {
    FormCampos,
    FormFiltros,
    FormRelatorio,
    FormFavoritos,
  },

  data() {
    return {
      //Lists
      listRelatorios: [],
      listCampos: [],
      listFiltros: [],
      listRegionaisUsuario: [],

      // Seleções
      relatorioSelecionado: null,
      camposSelecionados: [],
      filtrosSelecionados: [],
      filtrosFavoritoSelecionado: [],
      camposFavoritoSelecionado: [],

      // Relatório
      relatorioGerado: null,

      //Configs
      regionaisUsuario: null,
      idEmpresa: null,
      idUsuario: null,
      isLoading: true,
      filtroPreparado: false,
      listas: null,
    };
  },

  methods: {
    abreModalFavoritos(value) {
      const objSend = {
        campos: this.camposSelecionados,
        where: this.filtrosSelecionados,
        idRelatorio: this.relatorioSelecionado.idRelatorio,
      };
      this.$refs.formFavoritos.abreModalFavoritos(value, objSend);
    },

    alteraCamposSelecionados(value) {
      this.camposSelecionados = [];
      value.forEach((item) => {
        this.camposSelecionados.push(item.campo);
      });
    },

    alteraFiltrosSelecionados(value) {
      this.filtrosSelecionados = [];

      value.forEach((filtro) => {
        let valorFinal = null;

        if (Array.isArray(filtro.valor)) {
          valorFinal = filtro.valor.map((item) => {
            return item.id;
          });
        } else {
          valorFinal = filtro.valor.id ? filtro.valor.id : filtro.valor;
        }

        this.filtrosSelecionados.push({
          campo: filtro.campo,
          labelCampo: filtro.label,
          operador: filtro.operador.id,
          valor: valorFinal,
        });
      });
    },

    favoritoSelecionado(favorito) {
      this.$vs.loading();
      const relatorioFavorito = this.listRelatorios.find(
        (item) => item.idRelatorio == favorito.idRelatorio,
      );
      this.selecionaRelatorio(relatorioFavorito);

      setTimeout(() => {
        this.camposFavoritoSelecionado = favorito.filtro.campos;
        this.filtrosFavoritoSelecionado = favorito.filtro.where;
        this.$vs.loading.close();
      }, 2500);
    },

    getDecoded() {
      const token = localStorage.getItem('user-token');
      if (token) {
        this.decoded = jwt.decode(token);
        this.idEmpresa = this.decoded.id_empresa;
        this.idUsuario = this.decoded.id_usuario;
      }
    },

    async obterDadosUsuario() {
      try {
        this.$vs.loading();
        this.getDecoded();
        await this.buscaRegionais(this.idEmpresa, this.idUsuario);
        this.$vs.loading.close();
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },

    async buscaRegionais(idEmpresa, idUsuario) {
      try {
        this.$vs.loading();

        const result = await service.getAll(
          'Usuario',
          {},
          `list/${idEmpresa}?idUsuario=${idUsuario}`,
        );

        const [dados] = result.data;
        const { usuarios_regionais, Usuarios_Regional } = dados;

        const listIdsRegionais = usuarios_regionais.map((item) => ({
          id: item.id_regional,
          label: item.nome,
        }));

        this.listRegionaisUsuario = this.regionaisUsuario = [
          { id: Usuarios_Regional.idRegional, label: Usuarios_Regional.nome },
          ...listIdsRegionais,
        ];
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },

    selecionaRelatorio(item) {
      this.listRelatorios.forEach((relatorio) => {
        delete relatorio.selecionado;
      });

      item.selecionado = true;
      this.relatorioSelecionado = item;
      this.camposSelecionados = [];
      this.filtrosSelecionados = [];
      this.listCampos = [];
      this.listFiltros = [];
      this.camposFavoritoSelecionado = [];
      this.filtrosFavoritoSelecionado = [];
      this.preparaCamposFiltros();
    },

    async buscaListaRelatorios() {
      try {
        this.$vs.loading();

        const result = await service.getAll(
          'Dinamicos',
          {},
          `list/${this.idEmpresa}`,
        );

        const listRelatoriosCompleto = [];

        result.data.forEach((element) => {
          element.campos = JSON.parse(element.campos);
          element.filtros = JSON.parse(element.filtros);
          listRelatoriosCompleto.push(element);
        });

        listRelatoriosCompleto.forEach((relatorio) => {
          if (this.$can(relatorio.nomeRelatorio, 'Dinamicos')) {
            this.listRelatorios.push(relatorio);
          }
        });

        this.sortAlfabeticoRelatorio(this.listRelatorios);
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },

    async preparaCamposFiltros() {
      try {
        this.$vs.loading();

        const listas = this.relatorioSelecionado.filtros.filter(
          (x) => x.tipo == 'lista',
        );
        const objSend = { listas: [] };

        listas.forEach((element) => {
          objSend.listas.push(element.nomeLista);
        });

        const result = await service.post(
          'Dinamicos',
          'PrepararFiltro',
          objSend,
        );

        this.listCampos = this.sortAlfabetico(this.relatorioSelecionado.campos);
        this.listFiltros = this.sortAlfabetico(
          this.relatorioSelecionado.filtros,
        );

        this.listas = result.data;
        this.listas['listaRegional'] = this.regionaisUsuario;
        this.filtroPreparado = true;
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },

    sortAlfabeticoRelatorio(array) {
      const arraySorted = array.sort((a, b) => {
        const labelA = a.nomeRelatorio.toUpperCase();
        const labelB = b.nomeRelatorio.toUpperCase();
        if (labelA < labelB) {
          return -1;
        }
        if (labelA > labelB) {
          return 1;
        }
        return 0;
      });
      this.listRelatorios = arraySorted;
    },

    sortAlfabetico(array) {
      const arraySorted = array.sort((a, b) => {
        const labelA = a.label.toUpperCase();
        const labelB = b.label.toUpperCase();
        if (labelA < labelB) {
          return -1;
        }
        if (labelA > labelB) {
          return 1;
        }
        return 0;
      });

      const arrayAgrupado = [];

      arraySorted.forEach((obj) => {
        const letraInicial = obj.label.charAt(0).toUpperCase();
        if (!arrayAgrupado[letraInicial]) {
          arrayAgrupado[letraInicial] = [];
        }
        arrayAgrupado[letraInicial].push(obj);
      });

      return Object.keys(arrayAgrupado)
        .sort()
        .map((letra) => {
          return arrayAgrupado[letra];
        });
    },

    async geraRelatorioDinamico() {
      try {
        if (this.camposSelecionados.length == 0) {
          throw new Error(
            'É necessário selecionar um ou mais campos para fazer uma consulta',
          );
        }

        this.$vs.loading();

        const objSend = {
          campos: this.camposSelecionados,
          where: this.filtrosSelecionados,
          regionaisUsuario: this.regionaisUsuario,
          idEmpresa: this.idEmpresa,
          idRelatorio: this.relatorioSelecionado.idRelatorio,
        };

        const result = await service.post('Dinamicos', 'Buscar', objSend);
        this.relatorioGerado = result.data;
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
  },

  async mounted() {
    await this.obterDadosUsuario();
    await this.buscaListaRelatorios();
    this.isLoading = false;
  },
};
</script>
<style></style>
